import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Layout } from './components/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import PublicRidePage from './pages/PublicRidePage';
import PublicInvitePage from './pages/PublicInvitePage';
import ManageRidePage from './pages/ManageRidePage';
import GuestCollectionPage from './pages/GuestCollectionPage';
import GiftPublicPage from './pages/GiftPublicPage';
import WeddingPublicPage from './pages/WeddingPublicPage';
import PlatformCouplesPage from './pages/PlatformCouplesPage';
import WhatsAppConnectPage from './pages/WhatsAppConnectPage';
import GoogleAuthPage from './pages/GoogleAuthPage';

function Protected({ children }: { children: JSX.Element }) {
  const { account, loading } = useAuth();
  if (loading) {
    return (
      <div dir="rtl" className="min-h-full grid place-items-center">
        <div className="flex flex-col items-center gap-3 animate-fade-in">
          <div className="h-10 w-10 rounded-2xl bg-sage-600/90 animate-pulse" />
          <p className="text-sm text-ink-faint">טוען…</p>
        </div>
      </div>
    );
  }
  if (!account) return <Navigate to="/login" replace />;
  return children;
}

function PlatformOnly({ children }: { children: JSX.Element }) {
  const { account } = useAuth();
  if (account?.account_type !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/i/:token" element={<PublicInvitePage />} />
      <Route path="/r/:token" element={<PublicRidePage />} />
      <Route path="/m/:token" element={<ManageRidePage />} />
      <Route path="/guest-collection/:token" element={<GuestCollectionPage />} />
      <Route path="/gift/:token" element={<GiftPublicPage />} />
      <Route path="/w/:token" element={<WeddingPublicPage />} />
      <Route path="/wedding/:token" element={<WeddingPublicPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/google-auth" element={<GoogleAuthPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<EventsPage />} />
        <Route path="events/:id" element={<EventDetailPage />} />
        <Route
          path="platform/couples"
          element={
            <PlatformOnly>
              <PlatformCouplesPage />
            </PlatformOnly>
          }
        />
        <Route
          path="platform/whatsapp"
          element={
            <PlatformOnly>
              <WhatsAppConnectPage />
            </PlatformOnly>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
